'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$7 = require('./styles-e0000262.js');
var component$7 = require('./component-eb14e0a9.js');

var AccordionTw = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, price = _a.price, description = _a.description, onClick = _a.onClick, isSelected = _a.isSelected, index = _a.index, content = _a.content, className = _a.className, testId = _a.testId;
    return (React__default.createElement(styles$7.Container, { className: className },
        React__default.createElement(component$7.SelectBlock, { title: title, className: "accordion-select-block", onClick: onClick, price: price, isSelected: isSelected, description: description, index: index, subtitle: subtitle, "data-testid": testId }),
        content && (React__default.createElement(styles$7.SelectContent, { className: "accordion-content", isSelected: isSelected }, content))));
};

exports.AccordionTw = AccordionTw;
